import { motion } from 'framer-motion'
import React from 'react'
import styled from 'styled-components'

import { SCALEUP_HOVER, SCALE_DOWN } from '../../utils/animation-config'

export interface IQuickLinkColors {
	background: string | undefined
	text: string | undefined
}

function QuickLink({ children, colors, url }: { children: React.ReactNode; colors?: IQuickLinkColors; url: string }) {
	return (
		<Anchor
			whileHover={SCALEUP_HOVER}
			whileTap={SCALE_DOWN}
			href={url}
			colors={colors}
		>
			{children}
		</Anchor>
	)
}

export default QuickLink

const Anchor = styled(motion.a)<{
	colors?: IQuickLinkColors
}>`
	all: unset;
	user-select: none;
	box-sizing: border-box;
	display: flex;
	align-items: center;
	padding: var(--spacer-sm) var(--spacer-md);
	background: var(--blue-100);
	color: var(--deep-blue);
	border-radius: 80px;

	${(p) => p.colors?.text && `color: ${p.colors.text}`};
	${(p) => p.colors?.background && `background: ${p.colors.background}`};

	height: 72px;
	cursor: pointer;

	font-family: var(--font-atyp-display);
	font-size: 1.375rem;
	line-height: 24px;
	font-weight: 500;

	&:focus-visible {
		outline: 2px solid var(--blue-700);
	}
`
